import { Reducer } from "redux";
import {
    resetAcquireMethodDataHandler,
    selectHealthCardAcquiringModeHandler,
    submitButtonDisabledStatusHandler,
    changeHealthCardNumberHandler,
    incrementNumberOfSubmitAttemptsHandler,
    toggleValidationMessageVisibilityHandler,
    changeValidationPostalCodeValueHandler,
    toggleShowPostalCodeConfirmationModalHandler,
    changeHealthCardMaskLocationHandler,
    loadClinicInformationHandler
} from './handlers';
import {
    TOGGLE_POSTAL_CODE_CONFIRMATION_MODAL,
    CHANGE_VERIFICATION_POSTAL_CODE,
    TOGGLE_VALIDATION_MESSAGE_VISIBILITY,
    INCREMENT_NUMBER_OF_ATTEMPTS,
    CHANGE_HEALTH_CARD_NUMBER,
    CHANGE_BUTTON_SUBMIT_STATUS,
    SELECT_HEALTHCARD_NUMBER_ACQUIRING_METHOD,
    RESET_ACQUIRE_METHODE_DATA,
    CHANGE_MASK_LOCATION
} from './constants';
import {
    AcquireHealthCardNumberState,
    ToggleShowPostalCodeConfirmationModalAction,
    ChangeValidationPostalCodeValueAction,
    ToggleValidationMessageVisibilityAction,
    IncrementNumberOfSubmitAttemptsAction,
    ChangeHealthCardNumberAction,
    SubmitButtonDisabledStatusAction,
    SelectHealthCardAcquiringModeAction,
    ACQUIRING_MODE,
    AcquireHealthCardNumberAction,
    ChangeHealthCardMaskLocationAction
} from "./type";
import { CountryCodes } from "../../constants/countries";
import { LOAD_CLINIC_INFORMATION } from "../ClinicInformation/constants";
import { LoadClinicInformationAction } from "../ClinicInformation/type";

/**
 * @name initialState
 * @type {AcquireHealthCardNumberState}
 * @description Initial state of this part of the store.
 */
export const initialState: AcquireHealthCardNumberState = {
    acquiringMode: ACQUIRING_MODE.SCANNER,
    isSubmitButtonActive: true,
    healthCardNumber: "",
    postalCodeEntered: "",
    healthCardNumberOfAttempts: 0,
    postalCodeNumberOfAttempts: 0,
    invalidHealthCardNumberDetected: false,
    invalidPostalCodeDetected: false,
    showPostalCodeConfirmationModal: false,
    showCreateNewPatientModal: false,
    maskCountry: CountryCodes.CA,
    maskRegion: "QC"
};


/**
 * @name reducer
 * @constructs AcquireHealthCardNumberState
 * @param {AcquireHealthCardNumberState} state 
 * @param {AcquireHealthCardNumberAction} action 
 */
const reducer: Reducer<AcquireHealthCardNumberState> = (state: AcquireHealthCardNumberState = initialState, action: AcquireHealthCardNumberAction) => {
    switch (action.type) {
        case RESET_ACQUIRE_METHODE_DATA:
            return resetAcquireMethodDataHandler(state);

        case SELECT_HEALTHCARD_NUMBER_ACQUIRING_METHOD:
            return selectHealthCardAcquiringModeHandler(state, action as SelectHealthCardAcquiringModeAction);

        case CHANGE_HEALTH_CARD_NUMBER:
            return changeHealthCardNumberHandler(state, action as ChangeHealthCardNumberAction);

        case CHANGE_BUTTON_SUBMIT_STATUS:
            return submitButtonDisabledStatusHandler(state, action as SubmitButtonDisabledStatusAction);

        case INCREMENT_NUMBER_OF_ATTEMPTS:
            return incrementNumberOfSubmitAttemptsHandler(state, action as IncrementNumberOfSubmitAttemptsAction);

        case TOGGLE_VALIDATION_MESSAGE_VISIBILITY:
            return toggleValidationMessageVisibilityHandler(state, action as ToggleValidationMessageVisibilityAction);

        case CHANGE_VERIFICATION_POSTAL_CODE:
            return changeValidationPostalCodeValueHandler(state, action as ChangeValidationPostalCodeValueAction);

        case TOGGLE_POSTAL_CODE_CONFIRMATION_MODAL:
            return toggleShowPostalCodeConfirmationModalHandler(state, action as ToggleShowPostalCodeConfirmationModalAction);

        case CHANGE_MASK_LOCATION:
            return changeHealthCardMaskLocationHandler(state, action as ChangeHealthCardMaskLocationAction);

        case LOAD_CLINIC_INFORMATION:
            return loadClinicInformationHandler(state, action as LoadClinicInformationAction);

        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/AcquireHealthCardNumber/reducer.ts